import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const PollList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const PollHeaderRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
})

const PollQuestion = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PollClosedTag = styled('span', {
  base: {
    paddingX: '8px',
    paddingY: '2px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    backgroundColor: '#EFEDF5',
    color: '#5A4F78',
  },
})

const OptionList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '14px',
  },
})

const VoteOptionButton = styled('button', {
  base: {
    width: '100%',
    textAlign: 'left',
    paddingX: '16px',
    paddingY: '12px',
    borderRadius: 'md',
    border: '1px solid #E4E0EF',
    backgroundColor: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
    cursor: 'pointer',
    transition: 'all {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      backgroundColor: 'quickpass.primarySoft',
    },
    _disabled: {
      opacity: '0.6',
      cursor: 'default',
    },
  },
})

const ResultRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const ResultLabelRow = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
})

const ResultLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const ResultCount = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    whiteSpace: 'nowrap',
  },
})

const ResultBarTrack = styled('div', {
  base: {
    width: '100%',
    height: '8px',
    borderRadius: 'pill',
    backgroundColor: '#EFEDF5',
    overflow: 'hidden',
  },
})

const ResultBarFill = styled('div', {
  base: {
    height: '100%',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.primary',
    transition: 'width {durations.fast} {easings.appleStandard}',
  },
})

const PollMeta = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    marginTop: '12px',
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
  PollList,
  PollHeaderRow,
  PollQuestion,
  PollClosedTag,
  OptionList,
  VoteOptionButton,
  ResultRow,
  ResultLabelRow,
  ResultLabel,
  ResultCount,
  ResultBarTrack,
  ResultBarFill,
  PollMeta,
}
